class CatalogMenu {
	domElement;
	overlayElement;
	toggleButtons;
	headerElement;
	tabButtons;
	tabPanels;
	isOpen;
	boundOnEsc;

	constructor(rootElement) {
		if (!rootElement) {
			return;
		}
		this.domElement = rootElement;
		this.overlayElement = this.domElement.querySelector('.catalog-menu__overlay');
		this.toggleButtons = document.querySelectorAll('.header__actions-catalog');
		this.headerElement = document.querySelector('.header');
		this.tabButtons = this.domElement.querySelectorAll('.catalog-menu__item');
		this.tabPanels = this.domElement.querySelectorAll('.catalog-menu__current-item-inner');
		this.isOpen = this.domElement.classList.contains('active');
		this.boundOnEsc = this.onEscPress.bind(this);
		this.init();
	}

	init = () => {
		// Toggle buttons in header
		if (this.toggleButtons && this.toggleButtons.length > 0) {
			this.toggleButtons.forEach((button) => {
				button.addEventListener('click', (event) => {
					event.preventDefault();
					this.toggle();
					this.updateAria(button);
				});
				this.updateAria(button);
			});
		}

		// Overlay to close
		if (this.overlayElement) {
			this.overlayElement.addEventListener('click', () => this.close());
		}

		// Tabs
		this.initTabs();
	};

	open = () => {
		if (this.isOpen) return;
		this.domElement.classList.add('active');
		document.body.classList.add('overflow-hidden');
		this.isOpen = true;
		document.addEventListener('keydown', this.boundOnEsc);
		this.updateAllButtonsAria(true);
		this.updateButtonsActiveState(true);
		if (this.headerElement) {
			this.headerElement.classList.add('header--menu-open');
		}

		// Ensure a tab is active on open (desktop only)
		const isMobile = window.matchMedia('(max-width: 767px)').matches;
		if (!isMobile) {
			if (!this.domElement.querySelector('.catalog-menu__current-item-inner.is-active')) {
				this.activateTab(0);
			}
		} else {
			// On mobile start in items list view
			this.domElement.classList.remove('is-detail-view');
		}
	};

	close = () => {
		if (!this.isOpen) return;
		document.body.classList.remove('overflow-hidden');
		this.domElement.classList.remove('active');
		this.isOpen = false;
		document.removeEventListener('keydown', this.boundOnEsc);
		this.updateAllButtonsAria(false);
		this.updateButtonsActiveState(false);
		if (this.headerElement) {
			this.headerElement.classList.remove('header--menu-open');
		}
		this.domElement.classList.remove('is-detail-view');
	};

	toggle = () => {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	};

	onEscPress = (event) => {
		if (event.key === 'Escape') {
			this.close();
		}
	};

	updateAria = (button) => {
		if (!button) return;
		button.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
		button.setAttribute('aria-controls', 'catalog-menu');
	};

	updateAllButtonsAria = (isExpanded) => {
		if (!this.toggleButtons) return;
		this.toggleButtons.forEach((button) => {
			button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
			button.setAttribute('aria-controls', 'catalog-menu');
		});
	};

	updateButtonsActiveState = (isActive) => {
		if (!this.toggleButtons) return;
		this.toggleButtons.forEach((button) => {
			button.classList.toggle('is-active', isActive);
		});
	};

	initTabs = () => {
		if (!this.tabButtons || !this.tabPanels) return;

		// Assign roles for accessibility
		const tablist = this.domElement.querySelector('.catalog-menu__items');
		if (tablist) {
			tablist.setAttribute('role', 'tablist');
		}

		this.tabButtons.forEach((btn, index) => {
			btn.setAttribute('role', 'tab');
			btn.setAttribute('aria-selected', 'false');
			btn.setAttribute('tabindex', '-1');
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				this.activateTab(index);
				// Enter detail view on mobile
				const isMobile = window.matchMedia('(max-width: 767px)').matches;
				if (isMobile) {
					this.domElement.classList.add('is-detail-view');
				}
			});
		});

		this.tabPanels.forEach((panel) => {
			panel.setAttribute('role', 'tabpanel');
			panel.setAttribute('aria-hidden', 'true');
			// Back button handler (mobile)
			const backButton = panel.querySelector('.catalog-menu__back');
			if (backButton) {
				backButton.addEventListener('click', (e) => {
					e.preventDefault();
					const isMobile = window.matchMedia('(max-width: 767px)').matches;
					if (isMobile) {
						this.domElement.classList.remove('is-detail-view');
						// Remove is-active class from active button
						const activeTab = this.domElement.querySelector('.catalog-menu__item.button-border-gradient.is-active');
						if (activeTab) {
							activeTab.classList.remove('is-active');
							activeTab.setAttribute('aria-selected', 'false');
							activeTab.setAttribute('tabindex', '-1');
						}
						// Optionally move focus back to the currently active tab
						if (activeTab && typeof activeTab.focus === 'function') {
							activeTab.focus();
						}
					}
				});
			}
		});
	};

	activateTab = (index) => {
		if (!this.tabButtons || !this.tabPanels) return;
		const total = Math.min(this.tabButtons.length, this.tabPanels.length);
		if (index < 0 || index >= total) return;

		this.tabButtons.forEach((btn, i) => {
			const isActive = i === index;
			btn.classList.toggle('is-active', isActive);
			btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
			btn.setAttribute('tabindex', isActive ? '0' : '-1');
		});

		this.tabPanels.forEach((panel, i) => {
			const isActive = i === index;
			panel.classList.toggle('is-active', isActive);
			panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
		});
	};
}

export { CatalogMenu };


